import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateMapping} from '../api';
import {MappingKind} from '../api/types';

interface Params {
  categorySlug: string;
  kind: MappingKind;
  entityId: string;
  id: number;
}

export const useUpdateMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({categorySlug, kind, entityId, id}: Params) =>
      updateMapping(categorySlug, kind, entityId, id),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['apiSportsMappings'],
      });
      void queryClient.invalidateQueries({
        queryKey: ['sportMatch'],
      });
    },
  });
};
